/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_BrandingInputs */

const en_val_branding = /** @type {(inputs: Val_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branding`)
};

const es_val_branding = /** @type {(inputs: Val_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branding`)
};

const fr_val_branding = /** @type {(inputs: Val_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image de marque`)
};

const de_val_branding = /** @type {(inputs: Val_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branding`)
};

const ja_val_branding = /** @type {(inputs: Val_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブランディング`)
};

const zh_val_branding = /** @type {(inputs: Val_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`品牌建设`)
};

const ar_val_branding = /** @type {(inputs: Val_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بناء العلامة التجارية`)
};

const id_val_branding = /** @type {(inputs: Val_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branding`)
};

const it_val_branding = /** @type {(inputs: Val_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branding`)
};

const ru_val_branding = /** @type {(inputs: Val_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Брендинг`)
};

const pt_val_branding = /** @type {(inputs: Val_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branding`)
};

const ko_val_branding = /** @type {(inputs: Val_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브랜딩`)
};

/**
* | output |
* | --- |
* | "Branding" |
*
* @param {Val_BrandingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_branding = /** @type {((inputs?: Val_BrandingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_BrandingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_branding(inputs)
	if (locale === "es") return es_val_branding(inputs)
	if (locale === "fr") return fr_val_branding(inputs)
	if (locale === "de") return de_val_branding(inputs)
	if (locale === "ja") return ja_val_branding(inputs)
	if (locale === "zh") return zh_val_branding(inputs)
	if (locale === "ar") return ar_val_branding(inputs)
	if (locale === "id") return id_val_branding(inputs)
	if (locale === "it") return it_val_branding(inputs)
	if (locale === "ru") return ru_val_branding(inputs)
	if (locale === "pt") return pt_val_branding(inputs)
	return ko_val_branding(inputs)
});